var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortSearch',{attrs:{"default-sort":"latest","dimension":"LatestDesigns","force-experience":_vm.getMerch,"query":"dog"}})
}
var staticRenderFns = []

export { render, staticRenderFns }